import { AiOutlinePieChart } from "react-icons/ai";

import {
  ArcElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ArcElement
);

interface Req {
  arrayGraficoFluxo;
}

export function PieChart1(props: Req) {
  let valor = [];
  let descricao = [];
  let cores = [];

  var grafico = props.arrayGraficoFluxo;

  valor = grafico?.map((item, indice) => item.valor) || [];

  descricao = grafico?.map((item) => item.descricao) || [];

  cores = [
    "#E3A254",
    "hsl(133, 67%, 65%)",
    "#6969e2",
    "hsl(0, 68%, 65%)",
    "#CD853F",
    "#69e2e2",
    "#e1b74c",
    "#D2691E",
    "#F4A460",
    "#FFDEAD",
    "#F5DEB3",
    "#FA8072",
    "#FF7F50",
  ];

  var valoresPorcentagem;
  if (valor.length !== 0) {
    const soma = valor.reduce(function (acc, value) {
      return acc + value;
    });

    const porcentagem = valor.map((element) => {
      let i = (element / soma) * 100;
      return i;
    });
    valoresPorcentagem = porcentagem;
  }

  const dataPie = {
    datasets: [
      {
        data: valor,
        backgroundColor: cores,
        borderColor: cores,
        borderWidth: 1,
      },
    ],
  };

  return (
    <>
      <div className="text">
        <p>Cliente por Fluxo</p>
        <i>
          <AiOutlinePieChart />
          <p>{valor.length}</p>
        </i>
      </div>
      <div className="pie">
        <div>
          <Pie data={dataPie} style={{ maxHeight: "150px" }} />
        </div>
      </div>

      <div className="pie">
        <div className="infos-pie">
          {descricao.map((item, index) => (
            <h6 key={index}>
              <span style={{ backgroundColor: cores[index] }}>.</span> {item}: (
              {valoresPorcentagem[index].toFixed(1)})%
            </h6>
          ))}
        </div>
      </div>
    </>
  );
}
